module.exports = __webpack_public_path__ + "img/16-image-1@2x.3b76a861.png";